import {
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
import { securityInsightsApiRef } from './api/apiRef';
import { SecurityInsightsClient } from './api/SecurityInsightsClient';
import { rootRouteRef } from './routes';

export const securityInsightsPlugin = createPlugin({
  id: 'security-insights',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: securityInsightsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new SecurityInsightsClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const SecurityInsightsRouter = securityInsightsPlugin.provide(
  createRoutableExtension({
    name: 'SecurityInsightsRouter',
    component: () => import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
